import { Stack, Typography, Chip } from '@mui/material';

export default function SectionTitle({ icon, title, badge, badgeColor = 'primary' }) {
  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      {icon && (
        <Typography component="span" sx={{ fontSize: 16 }}>
          {icon}
        </Typography>
      )}
      <Typography variant="subtitle2" sx={{ fontWeight: 700, color: 'text.primary' }}>
        {title}
      </Typography>
      {badge && (
        <Chip
          size="small"
          label={badge}
          color={badgeColor}
          variant="filled"
          sx={{
            height: 20,
            fontSize: 10.5,
            fontWeight: 700,
            bgcolor: 'primary.lighter',
            color: 'primary.dark',
            '& .MuiChip-label': { px: 1 },
          }}
        />
      )}
    </Stack>
  );
}
